<template>
    <div class="vimeo-container">
        <div class="vimeo-player" ref="vimeoPlayer" id="vimeoPlayer" v-show="isReady"></div>
        <div class="loader" v-show="!isReady">
            <loader :width="20" :height="20"/>
        </div>
    </div>
</template>

<script>
import Player from '@vimeo/player';
export default {
    name: 'VimeoPlayer',
    data() {
        return {
            isReady: false
        };
    },
    mounted() {
        this.player = new Player(this.$refs.vimeoPlayer, {
            id: this.videoId
        });

        this.player.on('loaded', data => {
            this.player.element.setAttribute('width', '100%');
            this.isReady = true;
        });
    },
    beforeDestroy() {
        this.player.off('loaded');
        this.player.destroy();
    },
    props: {
        videoId: {
            type: String,
            required: true
        },
        options: {
            typ: Object
        }
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/VimeoPlayer.vue